export const primarycolors = {
  name: 'Primary Colors',
  color: [0.984313725490196, 0.396078431372549, 0.25882352941176473, 1],
  bg: [0.21568627450980393, 0.3686274509803922, 0.592156862745098, 1],
  grid1: [1, 0.7333333333333333, 0, 1],
  grid2: [0.2823529411764706, 0.4196078431372549, 0, 1],
}
